import { render, staticRenderFns } from "./EmptyHero.vue?vue&type=template&id=32753808&scoped=true&"
import script from "./EmptyHero.vue?vue&type=script&lang=js&"
export * from "./EmptyHero.vue?vue&type=script&lang=js&"
import style0 from "./EmptyHero.vue?vue&type=style&index=0&id=32753808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32753808",
  null
  
)

export default component.exports